exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/_object-pie.js
// module id = 60
// module chunks = 99